import Image, { StaticImageData } from "next/legacy/image";
import Link from "next/link";
import React from "react";
import GaransiLogo from "public/assets/garansi-logo.svg";
import Avatar1 from "public/assets/usp/avatar-1.png";
import Avatar2 from "public/assets/usp/avatar-2.png";
import Avatar3 from "public/assets/usp/avatar-3.png";
import {
  TestimonialsSectionWrapper,
  TestimonialsContent,
  TestimonialsTitle,
  TestimonialsCardsRow,
  TestimonialCard,
  TestimonialText,
  TestimonialAuthor,
  TestimonialAvatar,
  TestimonialAuthorInfo,
  TestimonialAuthorName,
  TestimonialAuthorClass,
  GuaranteeBanner,
  GuaranteeBadge,
  GuaranteeTextWrapper,
  GuaranteeHeading,
  GuaranteeSubtext
} from "./testimonials-section.styles";

interface Testimonial {
  text: string;
  name: string;
  classInfo?: string;
  avatar: StaticImageData;
}

const testimonials: Testimonial[] = [
  {
    text: "Keren bgt colearn...ada report belajarnya,ada sesi dgn tanya jwb juga dgn wali, pembelajaran mengasyikkan...txs sy berharap colearn jauh lebih maju lagi dan keren",
    name: "@i***********",
    avatar: Avatar1
  },
  {
    text: "Anakku dr awal SMP sdh masuk colearn, Senin besok psas kelas 7, semoga nilai anakku lebih baik dr sebelumnya. Semoga di kelas 9 nnti ada bantuan latihan dr colearn untuk menghadapi TKA.",
    name: "@A*********",
    classInfo: "SMP kelas 7",
    avatar: Avatar2
  },
  {
    text: "anak saya sejak kelas 7 sampai dengan sekarang di kelas 9 ikut co learn, alhamdulillah nilai TKA matematika kemarin 80,00 Terima kasih co learn",
    name: "@E********",
    classInfo: "SMP Kelas 9",
    avatar: Avatar3
  }
];

export const TestimonialsSection: React.FC = () => {
  return (
    <TestimonialsSectionWrapper>
      <TestimonialsContent>
        <TestimonialsTitle>
          10.000+ murid tersebar di Indonesia
        </TestimonialsTitle>
        <TestimonialsCardsRow>
          {testimonials.map((testimonial) => (
            <TestimonialCard key={testimonial.name}>
              <TestimonialText>{testimonial.text}</TestimonialText>
              <TestimonialAuthor>
                <TestimonialAvatar>
                  <Image
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    layout="fill"
                    objectFit="cover"
                  />
                </TestimonialAvatar>
                <TestimonialAuthorInfo>
                  <TestimonialAuthorName>
                    {testimonial.name}
                  </TestimonialAuthorName>
                  {testimonial.classInfo && (
                    <TestimonialAuthorClass>
                      {testimonial.classInfo}
                    </TestimonialAuthorClass>
                  )}
                </TestimonialAuthorInfo>
              </TestimonialAuthor>
            </TestimonialCard>
          ))}
        </TestimonialsCardsRow>
        <GuaranteeBanner>
          <GuaranteeBadge>
            <Image
              src={GaransiLogo}
              alt="Garansi 100% uang kembali"
              layout="fill"
              objectFit="contain"
            />
          </GuaranteeBadge>
          <GuaranteeTextWrapper>
            <GuaranteeHeading>
              <p>Coba 1 bulan dulu</p>
              <p>Jika tidak cocok, garansi uang kembali</p>
            </GuaranteeHeading>
            <GuaranteeSubtext>
              Garansi uang kembali 100% di bulan pertama. Info selengkapnya:{" "}
              <Link href="/garansi-uang-kembali">klik di sini</Link>
            </GuaranteeSubtext>
          </GuaranteeTextWrapper>
        </GuaranteeBanner>
      </TestimonialsContent>
    </TestimonialsSectionWrapper>
  );
};
